export default {
  termsOfUse: 'Termini di Utilizzo',
  privacyPolicy: 'Informativa sulla Privacy',
  cookiesPolicy: 'Informativa sui Cookie',
  careers: 'Carriera',

  connectSocialMedia: 'Possiamo risolvere il problema al più presto?',
  copyright: 'Copyright',
  mtgAllRightsReserved: 'Cactus Communications. All rights reserved',
};
